import * as Yup from "yup";

export const shippingCostSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Nombre demaciado corto")
    .required("Campo requerido"),
  providerName: Yup.string()
    .min(2, "Nombre del proveedor demaciado corto")
    .required("Campo requerido"),
  price: Yup.number().required("Campo requerido"),
  cost: Yup.number().required("Campo requerido"),
  order: Yup.number(),
});
